import { TaxResultItemType } from './tax-result-item-type';

export class SecurityTaxResultItem {
  securityTaxResultItemId!: number;
  securityTaxResultItemRate!: number | null;
  securityTaxResultItemDescription!: string;
  taxResultItemType!: TaxResultItemType;
  isActive!: boolean;
  taxPolicyId!: number;
  taxRuleId!: number;
  taxResultItemId!: number;
  taxResultItemRate!: number | null;
  taxResultItemDescription!: string;
  transactionTypeName!: string;
  taxResultItemTypeId!: number;
}
